import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import * as Action from "../../_redux/applicantActions";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import { Checkbox, DatePicker } from "antd";
import moment from "moment";

const _init = {
  title: "",
  place: "",
  author: "",
  url: "",
  year: "",
};

const Portfolio = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [portfolioData, setPortfolioData] = useState({ list: [] });
  const { personalInfo } = useSelector(
    ({ applicant }) => ({
      personalInfo: applicant.personal_info,
    }),
    shallowEqual
  );

  // Validation schema
  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        title: Yup.string()
          .nullable()
          .required("Title is required"),
        place: Yup.string()
          .nullable()
          .required("Place is required"),
        author: Yup.string()
          .nullable()
          .required("Author is required"),
        url: Yup.string().nullable(),
        year: Yup.string()
          .nullable()
          .required("Year is required"),
      })
    ),
  });
  const handleSaveProfile = async (values) => {
    const response = await API.patch(
      "hrms_applicant/save-portfolios?id=" + id,
      values.list
    );
    if (response.data.success) {
      swalSuccess(response.data.message);
      dispatch(
        Action.createProfileScore(
          {
            name: ["Portfolio"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
            fetchData();
          }
        )
      );
    } else {
      swalError(response.data.message);
    }
  };

  const handleDeleteLanguage = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = portfolioData?.list;
        list.splice(index, 1);
        setPortfolioData({ list: list });
      }
    });
  };
  const handleAddLanguage = async (values) => {
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setPortfolioData({ list: data });
  };
  const fetchData = async () => {
    const response = await API.get("hrms_applicant/get-portfolios/" + id);
    if (response.data.success) {
      if (response.data.data.length) {
        setPortfolioData({
          list: response.data.data.map((d) => {
            return {
              id: d.id,
              title: d.title,
              place: d.place,
              author: d.author,
              url: d.url,
              year: d.year ? moment(d.year) : null,
            };
          }),
        });
      }
    } else {
      swalError(response.data.message);
    }
  };
  useEffect(() => {
    if (id) {
      // get-objective
      fetchData();
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [id]);

  const handleOnChangeNoPortfolio = (no_portfolio) => {
    const api = `/hrms_applicant/${id}`;
    // const api = `http://localhost:6003/api/v1/hrms_applicant/${id}`;
    API.patch(api, { no_portfolio })
      .then((res) => {
        if (res.data.success) {
          swalSuccess("Data updated successfully");
          if (no_portfolio) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Portfolio"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Portfolio"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
        } else {
          if (res.data.message) {
            swalError(res.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("something went wrong");
      });
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={portfolioData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Portfolio</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].title`}
                            label={"Portfolio Title"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(`list[${i}].title`, e.target.value);
                            }}
                            value={item.title}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].title`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].place`}
                            label={"Institute/Organization/Place"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(`list[${i}].place`, e.target.value);
                            }}
                            value={item.place}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].place`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          {/* <Input
                                                        name={`list[${i}].year`}
                                                        label={"Publish Year"}
                                                        isRequired
                                                        onChange={(e) => {
                                                            setFieldValue(`list[${i}].year`, e.target.value);
                                                        }}
                                                        value={item.year}
                                                    /> */}
                          <label className="required">Publish Year</label>
                          <DatePicker
                            name={`list[${i}].year`}
                            picker="year"
                            style={{ width: "100%" }}
                            value={item.year ? moment(item?.year) : null}
                            onChange={(val, str) => {
                              setFieldValue(`list[${i}].year`, str);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].year`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].url`}
                            label={"URL "}
                            onChange={(e) => {
                              setFieldValue(`list[${i}].url`, e.target.value);
                            }}
                            value={item.url}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].url`} />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <Input
                            name={`list[${i}].author`}
                            label={"Author"}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].author`,
                                e.target.value
                              );
                            }}
                            value={item.author}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].author`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={(e) => {
                                e.preventDefault();
                                handleAddLanguage(values);
                              }}
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Portfolio
                            </button>
                          )}

                          {row.length > 0 && (
                            <button
                              className="btn btn-danger btn-sm  text-nowrap"
                              onClick={(e) => {
                                e.preventDefault();
                                handleDeleteLanguage(item.id, i);
                              }}
                            >
                              <i
                                className="fa fa-minus  text-white"
                                aria-hidden="true"
                              ></i>
                              Remove Portfolio
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!values?.list?.length && (
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ display: "flex", gap: "2" }}
                >
                  {!personalInfo?.no_portfolio && (
                    <button
                      className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                        handleAddLanguage(values);
                      }}
                    >
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                      Add Portfolio
                    </button>
                  )}
                  <div className="align-content-center">
                    <Checkbox
                      type="checkbox"
                      checked={personalInfo?.no_portfolio}
                      id="no_portfolio"
                      onChange={(e) => {
                        handleOnChangeNoPortfolio(e.target.checked ? 1 : 0);
                      }}
                    />
                    <label
                      className="form-check-label ml-2"
                      htmlFor="no_portfolio"
                    >
                      <b>Don't have any portfolio?</b>
                    </label>
                  </div>
                </div>
              </div>
            )}
            {!personalInfo?.no_portfolio ? (
              <div className="edit_btn_group d-flex modal-footer m-0 p-0">
                {/* <button className='btn btn-default mr-4' >Cancel</button> */}
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            ) : (
              <></>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Portfolio;
